import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function KitHomeMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.kit.home);
  };

  return (
    <MainMenuItem
      itemTitleString="検査キットの\n在庫管理"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default KitHomeMenuItem;
